<template>
    <span>Logged out</span>
</template>

<script>
    export default {
        name: "OidcSignOutCallback",
        data() {
            return { }
        }
    }
</script>